import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchApiRoutes } from "./Actions/adminActions"; 
import routesData from "./Sidebar/Routes.json"
import Orders from "./Pages/Orders/Orders";
import AllUsers from "./Pages/Users/AllUsers";
import Dashboard from "./Pages/Dashboard/Dashboard";
import PendingFund from "./Pages/FundRequest/Pending";
import ApprovedFund from "./Pages/FundRequest/Approved";
import RejectedFund from "./Pages/FundRequest/Rejected";
import PendingWith from "./Pages/withdrawal/PendingWith";
import ApprovedWith from "./Pages/withdrawal/ApprovedWith";
import RejectedWith from "./Pages/withdrawal/RejectedWith";
import PendingReward from "./Pages/Rewards/PendingReward";
import ApprovedReward from "./Pages/Rewards/ApprovedReward";
import RejectedReward from "./Pages/Rewards/RejectedReward";
import EditProfile from "./Pages/EditProfile/EditProfile";
import PayoutManagement from "./Pages/PayoutReport/PayoutControls";
import ROILevelIncome from "./Pages/PayoutReport/ROILevelIncome";
import RoyaltyIncome from "./Pages/PayoutReport/RoyaltyIncome";
import LevelIncome from "./Pages/PayoutReport/LevelIncome";
import DirectIncome from "./Pages/PayoutReport/RoiIncome";
import RoyaltyBonus from "./Pages/PayoutReport/RoyaltyBonus";
import FundsManagement from "./Pages/FundRequest/FundControls";
import RewardsManagement from "./Pages/Rewards/RewardControls";
import WithdrawManagement from "./Pages/withdrawal/WithdrawControls";
import AddFunds from "./Pages/AddFund/AddFund";
import FundsHistory from "./Pages/FundHistory/FundHistory";
import BankDetails from "./Pages/BankReports/BankDetails";
import UPI from "./Pages/BankReports/Upi";
import BonanzaSetting from "./Pages/Bonanza/BonanzaSetting";
import Rank from "./Pages/Users/Rank";
import SIPManagement from "./Pages/SIP/SIP_controls";
import ActiveSIP from "./Pages/SIP/ActiveSIP";
import CompletedSIP from "./Pages/SIP/CompletedSIP";
import ActiveSIPDetails from "./Pages/SIP/ActiveSIP_Details";
import KycControls from "./Pages/KYC Report/KycControls";
import KycReport from "./Pages/KYC Report/KycReport";
import InstallmentManagement from "./Pages/Installments/InstallmentControls";
import UpcomingInstallment from "./Pages/Installments/UpcomingInstallment";
import UnpaidInstallment from "./Pages/Installments/UnpaidInstallment";
import BondPaper from "./Pages/Bond Paper/BondPaper";
import FundTransferHistory from "./Pages/FundTransferHistory/FundTransferHistory";
import AddFundHistory from "./Pages/AddFund/AddFundHistory";
import Web3 from "./Pages/BankReports/Web3.jsx";
import News from "./Pages/News/News.jsx";
import AddNews from "./Pages/News/AddNews.jsx";
import GeneralSettings from "./Pages/GeneralSettings/GeneralSettings.jsx";
import WithdrawnDetails from "./Pages/withdrawal/WithdrawDetails.jsx";
import RetrieveFunds from "./Pages/Retrieve Fund/RetrieveFunds.jsx";
import RetrieveFundHistory from "./Pages/RetrieveFundHistory/RetrieveFundHistory.jsx";
import ContractWithdrawal from "./Pages/Contract Withdrawal/ContractWithdrawal.jsx";
import TopUp   from "./Pages/TopUp/TopUp.jsx"
import PackagePurchase from "./Pages/PackagePurchase/PackagePurchase.jsx";
import GivePower from "./Pages/GivePower/GivePower.jsx";
import UserRegister from "./Pages/UserRegister/UserRegister.jsx";
import Support from "./Pages/Support/Support";
import ChatTickets from "./Pages/Support/ChatTickets";
import ControlsReleaseIncome from "./Pages/ReleaseIncome/ControlsReleaseIncome";
import PendingIncome from "./Pages/ReleaseIncome/PendingIncome";
import ReleasedIncome from "./Pages/ReleaseIncome/ReleasedIncome";
import CommunityIncome from "./Pages/PayoutReport/CommunityIncome.jsx";
import SalaryIncome from "./Pages/PayoutReport/SalaryIncome.jsx";
import UtilityIncome from "./Pages/PayoutReport/UtilityIncome.jsx";
import AddCapping from "./Pages/Add Capping/AddCapping.jsx";
import CoinSettings from "./Pages/CoinSetting/CoinSettings";
import ROILevelIncome2 from "./Pages/PayoutReport/ROILevelIncome2.jsx";
import BonusIncome from "./Pages/PayoutReport/BonusIncome.jsx";
import BonusIncomeSetting from "./Pages/BonusIncomeSetting/BonusIncomeSetting.jsx";
import UplineBonus from "./Pages/Users/UplineBonus.jsx";
import RoleSettings from "./Pages/RoleSettings/RoleSettings.jsx";
import UpdateRole from "./Pages/RoleSettings/UpdateRole.jsx";
import ChangePassword from "./Pages/ChangePassword/ChangePassword.jsx";
import PrincipleWithdrawalStatus from "./Pages/PrincipalWithStatus/PrincipalWithStatus.jsx";
import BroadCastInfo from "./Pages/BroadCastInfo/BroadCastInfo.jsx";
import LeadershipReward from "./Pages/PayoutReport/LeadershipReward.jsx";
import TeamBonus from "./Pages/PayoutReport/TeamBonus.jsx";
import UpdateBonusIncome from "./Pages/UpdateBonusIncome/UpdateBonusIncome.jsx";
import UserAddedFundHistory from "./Pages/AddFund/UserAddedFundHistory.jsx";
import RewardSettings from "./Pages/RewardSettings/RewardSettings.jsx";
import RewardIncome from "./Pages/PayoutReport/RewardIncome.jsx";
import BoosterIncome from "./Pages/PayoutReport/BoosterIncome.jsx";
import InfinityIncome from "./Pages/PayoutReport/InfinityIncome.jsx";
import CompoundingIncome from "./Pages/PayoutReport/CompoundingIncome.jsx";
import RankIncome from "./Pages/PayoutReport/RankIncome.jsx";
import ReferralIncome from "./Pages/PayoutReport/ReferralIncome.jsx";
import IncomeSetting from "./Pages/IncomeSetting/IncomeSetting.jsx";
import ClosingCron from "./Pages/ClosingCron/ClosingCron.jsx";
const NavPages = () => {

  const { routes } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
   const [permissions, setPermissions] = useState({});

   var x = 0;
   useEffect(() => {
     if (x === 0) dispatch(fetchApiRoutes());
     x++;
   }, [dispatch]);
 
   useEffect(() => {
     if (routes?.routes?.length > 0) {
       const updatedPermissions = {};
       // console.log("local routes", routesData);
       routesData.forEach((localRoute) => {
         // console.log("api routes", routes);
         const match = routes?.routes.find(
           (apiRoute) =>
             apiRoute.path === localRoute.path &&
             apiRoute.showInMenu === localRoute.showInMenu
         );
 
         if (match) {
           // console.log(`Matched Route:`, localRoute.path);
           updatedPermissions[localRoute.stateKey] = true; // Enable section
         }
       });
       console.log("updatedPermissions", updatedPermissions);
       setPermissions(updatedPermissions);
       // console.log(permissions);
     }
   }, [routes]);

  return (
    <React.Fragment>
      <section>
        <Routes>
        {permissions?.setDashboard &&(<Route path="/" element={<Dashboard />} />)}

        {permissions?.setPaymentTransactions&&(<Route path="/approved_fund" element={<ApprovedFund />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/pending_fund" element={<PendingFund />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/rejected_fund" element={<RejectedFund />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/fund_controls" element={<FundsManagement />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/fund_history" element={<FundsHistory />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/add_fund_history" element={<AddFundHistory />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/user_added_fund_history" element={<UserAddedFundHistory />} />)}
        {permissions?.setPaymentTransactions&&(<Route path="/fund_transfer_history" element={<FundTransferHistory />}/>)}
        {permissions?.setRewards && (<Route path="/rejected_reward" element={<RejectedReward />} />)}
        {permissions?.setRewards && (<Route path="/pending_reward" element={<PendingReward />} />)}
        {permissions?.setRewards && (<Route path="/approved_reward" element={<ApprovedReward />} />)}
        {permissions?.setRewards && (<Route path="/rewards" element={<RewardsManagement />} />)}
        {permissions?.setLevelRanks && (<Route path="/rank" element={<Rank />} />)}
        {permissions?.setPaymentsMethod && (<Route path="/chain" element={<Web3 />} />)}
        {/* Title Ranks /royalty hidden */}
        {permissions?.setPaymentTransactions && (<Route path="/withdraw_controls" element={<WithdrawManagement />} />)}
        {permissions?.setPaymentTransactions && (<Route path="/pending_withdrawal" element={<PendingWith />} />)}
        {permissions?.setPaymentTransactions && (<Route path="/approved_withdrawal" element={<ApprovedWith />} />)}
        {permissions?.setPaymentTransactions && (<Route path="/rejected_withdrawal" element={<RejectedWith />} />)}
        {permissions?.setUsers && (<Route path="/all_users" element={<AllUsers />} />)}
        {permissions?.setUsers && (
          <Route path="/package_purchase" element={<PackagePurchase />} />
        )}
        { permissions?.setCheckUsername && permissions?.setAllPackage &&(<Route path="/top_up" element={<TopUp />} />)}
          <Route path="/give_power" element={<GivePower />} />
          <Route path="/add_capping" element={<AddCapping />} />
        {/* Closing link hidden */}
        {permissions?.setIncomes && (<Route path="/payout_controls" element={<PayoutManagement />} />)}
        {permissions?.setIncomes && (<Route path="/level_income" element={<ROILevelIncome />} /> )}
        {permissions?.setIncomes && (<Route path="/roi_income" element={<DirectIncome />} />)}
        {permissions?.setIncomes && (<Route path="/bonus_income" element={<BonusIncome />} />)}
        {permissions?.setIncomes && (<Route path="/roi_level_income" element={<ROILevelIncome2 />} />)}
        {permissions?.setIncomes && (<Route path="/team_royalty_income" element={<RoyaltyIncome />} />)}
        {permissions?.setIncomes && ( <Route path="/royalty_income" element={<RoyaltyBonus />} />)}
        {permissions?.setIncomes && (<Route path="/upline_income" element={<LevelIncome />} />)}
          {permissions?.setIncomes && (<Route path="/leadership_reward" element={<LeadershipReward />} />)}
          {permissions?.setIncomes && (<Route path="/direct_income" element={<TeamBonus />} />)}
        {permissions?.setIncomes && ( <Route path="/community_income" element={<CommunityIncome />} />)}
        {permissions?.setIncomes && (<Route path="/roi_level_income" element={<SalaryIncome />} />)}
        {permissions?.setIncomes && (<Route path="/booster_income" element={<BoosterIncome />} />)}
        {permissions?.setIncomes && (<Route path="/infinity_income" element={<InfinityIncome />} />)}
        {permissions?.setIncomes && (<Route path="/utility_income" element={<UtilityIncome />} />)}
        {permissions?.setIncomes && (<Route path="/compounding_income" element={<CompoundingIncome />} />)}
        {permissions?.setIncomes && (<Route path="/rank_income" element={<RankIncome />} />)}
        {permissions?.setIncomes && (<Route path="/referral_income" element={<ReferralIncome />} />)}
        {permissions?.setAllOrders && (<Route path="/orders" element={<Orders />} />)}
        {permissions?.setUserPasswordUpdate && permissions?.setUserProfileUpdate&&(<Route path="/edit-profile" element={<EditProfile />} />)}
        {permissions?.setFunds && (<Route path="/add_fund" element={<AddFunds />} />)}
        {permissions?.setPaymentsMethod && (<Route path="/bank" element={<BankDetails />} />)}
        {permissions?.setPaymentsMethod && (<Route path="/select_upi" element={<UPI />} />)}
        {permissions?.setBonanzaSettings && (<Route path="/bonanza_setting" element={<BonanzaSetting />} />)}
          <Route path="/sip_controls" element={<SIPManagement />} />
          <Route path="/active_sip" element={<ActiveSIP />} />
          <Route path="/completed_sip" element={<CompletedSIP />} />
          <Route path="/active_sip_details" element={<ActiveSIPDetails />} />
        {permissions?.setKycRequest && (<Route path="/kyc_detail" element={<KycReport />} />)}
        {permissions?.setKycRequest && (<Route path="/kyc_controls" element={<KycControls />} />)}
          <Route path="/installment_controls" element={<InstallmentManagement />}/>
          <Route path="/upcoming_installment" element={<UpcomingInstallment />}/>
          <Route path="/unpaid_installment" element={<UnpaidInstallment />} />
          <Route path="/bond_paper" element={<BondPaper />} />
        {permissions?.setNews && (<Route path="/news" element={<News />} />)}
        {(permissions?.setAddNews || permissions?.setNews) && (
          <Route path="/add_news" element={<AddNews />} />
        )}
        {permissions?.setAdvanceInfo &&(<Route path="/general_settings"   element={<GeneralSettings />} />)}
          <Route path="/withdraw-details" element={<WithdrawnDetails />} />
          <Route path="/retrieve_fund" element={<RetrieveFunds />} />
          <Route path="/retrieve_fund_history" element={<RetrieveFundHistory />} />
          <Route path="/contract_withdrawal" element={<ContractWithdrawal />} />
          <Route path="/user_register" element={<UserRegister />} />
        {permissions?.setAllTickets && (<Route path="/support"   element={<Support />} />)}
          <Route path="/chat" element={<ChatTickets />} />
          <Route path="/released_income" element={<ReleasedIncome />} />
          <Route path="/pending_income" element={<PendingIncome />} />
          <Route path="/release_income_controls" element={<ControlsReleaseIncome />} />
        {permissions?.setCompanyInfo && (<Route path="/coin_settings"   element={<CoinSettings />} />)}
        {permissions?.setCompanyInfo && (<Route path="/principal_withdrawal_setting"   element={<PrincipleWithdrawalStatus />} />)}
        <Route path="/bonus_income_setting" element={<BonusIncomeSetting />} />
        {permissions?.setBroadCastInfo && (<Route path="/broadcastInfo" element={<BroadCastInfo />} />)}
        {permissions?.setUplineBonus && (<Route path="/upline_bonus" element={<UplineBonus />} /> )}
        <Route path="/reward_income" element={<RewardIncome />} />
        {permissions?.setRoutesByRole && (<Route path="/role_settings" element={<RoleSettings />} />)}
        {permissions?.setUpdateRouteRole && (<Route path="/update_role_settings" element={<UpdateRole />} />)}
        {permissions?.setChangePassword && (<Route path="change_password" element={<ChangePassword/>}/>)}
        {permissions?.setChangePassword && (<Route path="update_bonus_income" element={<UpdateBonusIncome/>}/>)}
        <Route path="/reward_settings" element={<RewardSettings />} />
        <Route path="/income_setting" element={<IncomeSetting />} />
        <Route path="/closing" element={<ClosingCron />} />
        </Routes>
      </section>
    </React.Fragment>
  );
};

export default NavPages;
